var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9 0c-3.21539021 0-6.18653343 1.71539025-7.79422861 4.5-1.60769519 2.78460967-1.60769519 6.2153903 0 9 1.60769518 2.7846097 4.5788384 4.5 7.79422861 4.5 3.2153905 0 6.1865337-1.7153902 7.7942289-4.5 1.6076952-2.7846097 1.6076952-6.21539034 0-9-1.6076952-2.78460977-4.5788384-4.5-7.7942289-4.5z",
    fill: "currentColor",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.44000013 9.339 2.167 2.167-.02-.02 4.87999997-4.89",
    stroke: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/checked-circle.d705a95c50e63ec1b6d7fc5f5f48f4c4.svg";
export { ForwardRef as ReactComponent };